// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2gIeH","Logo":"Toolbar_Logo__PRnoS","spin":"Toolbar_spin__3dYEf","DesktopOnly":"Toolbar_DesktopOnly__2v9fr"};